import { CountryName, GeographyAirport, Name } from '@model/iceberg/geography';

export interface QuickestFlight {
  departure: GeographyAirport | null;
  arrival: GeographyAirport | null;
  flightTime: number;
}

export interface Destination {
  continent: Name;
  country: CountryName;
  region: Name | null;
  resorts: Array<Resort>;
  quickest: QuickestFlight;
  weather: any | null;
}

export interface DestinationExtended extends Destination {
  destination: Name;
}

export interface DestinationsResponse {
  destinations: Array<Destination>;
}

export interface Resort {
  name: Name;
  hotels: number;
}

export const GEO_LEVEL_ONE_COUNTRIES = ['Australia'];
